<div class="transaction-amount-options-wrapper">
  <div class="transaction-amount-options-title">Move funds from account based on<span class="asterisk">*</span></div>

  <div class="transaction-amount-options">
    @for (amountOption of amountOptionItems$ | async; track amountOption) {
      <div class="transaction-amount-option-item" [class.disabled]="(isDebitLegsDisabled$ | async) || amountOption.isDisabled">
        <label [for]="amountOption.value" class="transaction-amount-option-radio-input-label">
          <span class="transaction-amount-option-radio-input" [class.checked]="amountOptionField.value === amountOption.value"></span>
          <input
            hidden
            [id]="amountOption.value"
            [value]="amountOption.value"
            [attr.disabled]="(isDebitLegsDisabled$ | async) || amountOption.isDisabled ? true : null"
            [formControl]="amountOptionField"
            (change)="onAmountOptionSelect(amountOption.value)"
            name="transaction-amount-option"
            type="radio"
            class="form-check-input"
          />
          <span class="transaction-amount-option-item-value" [title]="amountOption.label">
            {{ amountOption.label }}
          </span>
          @if (amountOption.tooltip) {
            <app-tooltip class="tooltip" [tooltip]="amountOption.tooltip"></app-tooltip>
          }
        </label>
      </div>
    }
  </div>
</div>
